import { RichiestaDTO } from '@framework/api-client';
import { SubmissionCardTabPanel } from '@framework/common-web';
import { SubmissionPaymentsCard } from '@framework/frontoffice-submission';
import { t } from '@framework/i18n';

export interface ISubmissionSentTabPaymentsProps {
  active: boolean | null | undefined;
  submission: RichiestaDTO | null | undefined;
}

export function SubmissionSentTabPayments(
  props: ISubmissionSentTabPaymentsProps,
) {
  const { active, submission } = props;

  if (!active) return null;

  return (
    <SubmissionCardTabPanel
      active={active}
      label={t(
        'submission-sent-tab-payment.panel-aria',
        'Tab Pagamenti della richiesta',
      )}
    >
      <SubmissionPaymentsCard
        submissionId={submission?.id}
        handleNavigation={undefined}
        submission={submission}
        hideCard={true}
      />
    </SubmissionCardTabPanel>
  );
}
